import React from 'react'
import { Article } from 'shared/Article'
import { TeamSettings } from './blocks/TeamSettings/TeamSettings'
import { useSettings } from './useSettings'

export const Settings: React.FC = () => {
  const { isAdmin, dealership, setDealership } = useSettings()

  return (
    <Article heading="Team Settings" headerHasBottomBorder={false}>
      <TeamSettings
        dealership={dealership}
        setDealership={setDealership}
        isAdmin={isAdmin}
      />
    </Article>
  )
}
